import React from 'react';

const Title = () => {
  return (
    <div className="title">
      <h1>FireGram</h1>
      <h2>Our Pictures</h2>
      <p>These pictures are chosen by and from various people.</p>
    </div>
  )
}

export default Title;